/**
 * Rubina Irfan — Product Page JS
 * Gallery · Variant Selection · AJAX ATC · Qty Stepper · Wishlist · Size Modal
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     Helpers
  ───────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* This file's local formatMoney was the only correct one in the theme; it now
     lives in ri-money.js so the cart drawer and wishlist page share it rather
     than each carrying a broken copy. Written with innerHTML below, because
     shop.money_format contains markup (<span class=money>…</span>) that has to
     be parsed, not printed. */
  function formatMoney(cents, format) {
    return window.RIMoney.format(cents, format);
  }

  /* ─────────────────────────────────────────────
     Initialise on DOMContentLoaded
  ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var productDataEl = qs('#ri-product-data');
    if (!productDataEl) return;

    var productData;
    try { productData = JSON.parse(productDataEl.textContent); } catch (e) { return; }

    var variants    = productData.variants || [];
    var moneyFormat = productData.money_format || '${{amount}}';

    /* ── 1. GALLERY ── */
    initGallery();

    /* ── 2. VARIANT SELECTION ── */
    initVariants(variants, moneyFormat);

    /* ── 3. AJAX ATC ── */
    initATC();

    /* ── 3b. BUY NOW ── */
    initBuyNow();

    /* ── 4. QUANTITY STEPPER ── */
    initQty();

    /* ── 5. WISHLIST ── */
    initWishlist();

    /* ── 6. SIZE MODAL ── */
    initSizeModal();

    /* ── 7. DRAG TO SCROLL (Complete the Look) ── */
    initDragToScroll();
  });

  /* ─────────────────────────────────────────────
     1. GALLERY
  ───────────────────────────────────────────── */
  function initGallery() {
    var thumbsEl   = qs('#ri-thumbs');
    var mainEl     = qs('#ri-main-img');
    var lightbox   = qs('#ri-lightbox');
    var lightboxImg = qs('#ri-lightbox-img');

    if (!thumbsEl || !mainEl) return;

    var thumbs = qsa('.ri-product__thumb', thumbsEl);
    var slides = qsa('.ri-product__slide', mainEl);

    function goTo(index) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      if (thumbs[index]) thumbs[index].classList.add('is-active');
      if (slides[index]) slides[index].classList.add('is-active');
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(parseInt(btn.dataset.index, 10));
      });
    });

    /* Lightbox */
    if (!lightbox || !lightboxImg) return;

    mainEl.addEventListener('click', function () {
      var activeSlide = qs('.ri-product__slide.is-active', mainEl);
      if (!activeSlide) return;
      var img = qs('img', activeSlide);
      if (!img) return;
      lightboxImg.src = img.src.replace(/width=\d+/, 'width=2000');
      lightboxImg.alt = img.alt;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      qs('.ri-product__lightbox-close', lightbox).focus();
    });

    function closeLightbox() {
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    qs('.ri-product__lightbox-close', lightbox).addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') closeLightbox();
    });

    /* Touch swipe on main image */
    var swipeStartX = 0;
    var swipeStartY = 0;

    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    mainEl.addEventListener('touchstart', function (e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
    }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      var dx = swipeStartX - e.changedTouches[0].clientX;
      var dy = swipeStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        var idx = currentIndex();
        goTo(dx > 0
          ? (idx < slides.length - 1 ? idx + 1 : 0)
          : (idx > 0 ? idx - 1 : slides.length - 1));
      }
    }, { passive: true });

    /* Expose for variant selection to switch slides */
    window._riGalleryGoTo = goTo;
  }

  /* ─────────────────────────────────────────────
     2. VARIANT SELECTION
  ───────────────────────────────────────────── */
  function initVariants(variants, moneyFormat) {
    var swatches   = qsa('.ri-product__swatch');
    var chips      = qsa('.ri-product__chip');
    var variantIdEl = qs('#ri-variant-id');
    var atcBtn     = qs('#ri-atc-btn');
    var priceEl    = qs('.ri-product__price');
    var compareEl  = qs('.ri-product__price-compare');
    var availEl    = qs('.ri-product__availability');

    if (!variantIdEl) return;

    /* Build selected options array from currently active buttons */
    function getSelectedOptions() {
      var groups = {};
      qsa('.ri-product__swatch.is-active, .ri-product__chip.is-active').forEach(function (btn) {
        groups[btn.dataset.optionIndex] = btn.dataset.value;
      });
      var opts = [];
      var keys = Object.keys(groups).sort();
      keys.forEach(function (k) { opts.push(groups[k]); });
      return opts;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return [v.option1, v.option2, v.option3]
          .slice(0, selected.length)
          .every(function (o, i) { return o === selected[i]; });
      });
    }

    function updateUI(variant, changedOptionName) {
      if (!variant) return;

      /* Price */
      /* Fix: shop.money_format can contain HTML (e.g. <span class=money>{{amount}}</span>).
         Assigning that string via textContent renders the tags as literal text instead of
         parsing them, which is what broke the formatting on variant change. Use innerHTML
         so the markup in money_format is actually rendered, matching the server-rendered
         price on initial page load. */
      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price, moneyFormat);
        priceEl.classList.toggle('ri-product__price--sale', variant.compare_at_price > variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      /* Savings amount */
      var saveEl = qs('.ri-product__save');
      if (saveEl) {
        if (variant.compare_at_price > variant.price) {
          var savings = variant.compare_at_price - variant.price;
          saveEl.innerHTML = 'Save ' + formatMoney(savings, moneyFormat);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      /* Availability */
      if (availEl) {
        var dot = qs('.ri-avail-dot', availEl);
        if (variant.available) {
          availEl.innerHTML = '<span class="ri-avail-dot ri-avail-dot--in"></span> In Stock';
        } else {
          availEl.innerHTML = '<span class="ri-avail-dot ri-avail-dot--out"></span> Out of Stock';
        }
      }

      /* ATC button */
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      /* Hidden variant ID */
      variantIdEl.value = variant.id;

      /* Switch gallery to variant image — only for Color/Colour changes with assigned images */
      var isColorChange = changedOptionName && (changedOptionName.toLowerCase() === 'color' || changedOptionName.toLowerCase() === 'colour');
      if (isColorChange && variant.has_featured_image && typeof window._riGalleryGoTo === 'function') {
        window._riGalleryGoTo(variant.featured_image_index);
      }
    }

    function onOptionChange(btn, groupSel) {
      qsa(groupSel, btn.closest('.ri-product__option-group')).forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      var selected = getSelectedOptions();
      var variant  = findVariant(selected);
      var optionLabel = qs('.ri-product__option-label span', btn.closest('.ri-product__option-group'));
      var optionName = optionLabel ? optionLabel.textContent.trim() : '';
      if (variant) updateUI(variant, optionName);
      toggleSizeOption();
    }

    /* Toggle Size option visibility based on Type selection */
    function toggleSizeOption() {
      var typeGroup = qs('.ri-product__option-group--type');
      var sizeGroup = qs('.ri-product__option-group--size');
      if (!typeGroup || !sizeGroup) return;

      var activeChip = qs('.ri-product__chip.is-active', typeGroup);
      if (!activeChip) {
        // fallback: try swatches for Type (unlikely but possible)
        activeChip = qs('.ri-product__swatch.is-active', typeGroup);
      }

      if (activeChip) {
        var selectedType = activeChip.dataset.value || activeChip.textContent || '';
        selectedType = selectedType.trim();

        if (selectedType.toLowerCase() === 'unstitched') {
          document.body.classList.remove('type-stitched');
          sizeGroup.style.display = 'none';
          sizeGroup.style.opacity = '0';
        } else {
          document.body.classList.add('type-stitched');
          sizeGroup.style.display = '';
          // Small delay for CSS transition to work
          setTimeout(function() {
            sizeGroup.style.opacity = '1';
          }, 10);
        }
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { onOptionChange(btn, '.ri-product__swatch'); });
    });
    chips.forEach(function (btn) {
      btn.addEventListener('click', function () { onOptionChange(btn, '.ri-product__chip'); });
    });

    /* Run on initial load */
    setTimeout(toggleSizeOption, 100);
    setTimeout(toggleSizeOption, 500);
  }

  /* ─────────────────────────────────────────────
     3. AJAX ADD TO CART
  ───────────────────────────────────────────── */
  function initATC() {
    var form   = qs('#ri-atc-form');
    var msgEl  = qs('#ri-atc-msg');
    var atcBtn = qs('#ri-atc-btn');

    if (!form) return;

    /* Fix: same bfcache back-navigation issue as Buy Now — make sure "Adding…"
       never stays stuck on the button if the page is restored from cache. */
    if (atcBtn) {
      var atcDefaultLabel = atcBtn.textContent.trim() || 'Add to Cart';
      window.addEventListener('pageshow', function () {
        if (atcBtn.disabled && atcBtn.textContent.trim() === 'Adding…') {
          atcBtn.disabled = false;
        }
        if (atcBtn.textContent.trim() === 'Adding…') {
          atcBtn.textContent = atcDefaultLabel;
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = qs('#ri-variant-id', form);
      var qty       = qs('.ri-qty-input', form);
      if (!variantId) return;

      var body = JSON.stringify({
        id:       parseInt(variantId.value, 10),
        quantity: qty ? parseInt(qty.value, 10) : 1
      });

      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    body
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_error');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('ri:cart:updated'));
        if (msgEl) {
          msgEl.textContent = 'Added to Cart ✦';
          setTimeout(function () { msgEl.textContent = ''; }, 2000);
        }
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        }
      })
      .catch(function () {
        if (msgEl) {
          msgEl.textContent = 'Something went wrong. Please try again.';
          setTimeout(function () { msgEl.textContent = ''; }, 2000);
        }
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
     3b. BUY NOW
  ───────────────────────────────────────────── */
  function initBuyNow() {
    var buyNowBtn = qs('#ri-buy-now-btn');
    if (!buyNowBtn) return;

    var defaultLabel = buyNowBtn.textContent.trim() || 'Buy Now';

    function resetBuyNowButton() {
      buyNowBtn.disabled = false;
      buyNowBtn.textContent = defaultLabel;
    }

    /* Fix: when the shopper clicks Buy Now they navigate to /checkout, and the
       button is left disabled with "Processing…". If they then use the browser
       Back button, most browsers restore this page from the back/forward cache
       (bfcache) instead of reloading it — so that stale state stuck around.
       `pageshow` fires on every load, including bfcache restores, so resetting
       here guarantees the button is always back to normal when the page is shown. */
    window.addEventListener('pageshow', resetBuyNowButton);

    buyNowBtn.addEventListener('click', function () {
      var variantId = qs('#ri-variant-id');
      var qty       = qs('.ri-qty-input');
      if (!variantId) return;

      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Processing…';

      var body = JSON.stringify({
        id:       parseInt(variantId.value, 10),
        quantity: qty ? parseInt(qty.value, 10) : 1
      });

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    body
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_error');
        window.location.href = '/checkout';
      })
      .catch(function () {
        resetBuyNowButton();
      });
    });
  }

  /* ─────────────────────────────────────────────
     4. QUANTITY STEPPER
  ───────────────────────────────────────────── */
  function initQty() {
    qsa('.ri-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = qs('.ri-qty-input', btn.closest('.ri-product__qty'));
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.action === 'minus') val = Math.max(1,  val - 1);
        if (btn.dataset.action === 'plus')  val = Math.min(99, val + 1);
        input.value = val;
      });
    });
  }

  /* ─────────────────────────────────────────────
     5. WISHLIST
  ───────────────────────────────────────────── */
  function initWishlist() {
    var btn = qs('.ri-product__wishlist');
    if (!btn) return;

    var productDataEl = qs('#ri-product-data');
    if (!productDataEl) return;
    var data;
    try { data = JSON.parse(productDataEl.textContent); } catch (e) { return; }
    var productId     = data.product_id;
    var productHandle = data.product_handle;

    /* Wishlist items are stored as { id, handle } objects so the wishlist
       page can look each product up via /products/{handle}.js. Older
       entries saved before this field existed (plain ids) are dropped
       on next write since they can't be rendered on the wishlist page. */
    var wishlist = [];
    try {
      var raw = JSON.parse(localStorage.getItem('ri-wishlist') || '[]');
      wishlist = raw.filter(function (item) { return item && typeof item === 'object' && item.id; });
    } catch (e) {}

    var svg = qs('path', btn);

    function isWished() {
      return productId && wishlist.some(function (item) { return item.id === productId; });
    }

    function setWished(wished) {
      btn.classList.toggle('is-wished', wished);
      if (svg) svg.style.fill = wished ? 'currentColor' : 'none';
    }

    setWished(isWished());

    btn.addEventListener('click', function () {
      var wished = btn.classList.contains('is-wished');
      if (!wished) {
        if (productId && !isWished()) wishlist.push({ id: productId, handle: productHandle });
      } else {
        wishlist = wishlist.filter(function (item) { return item.id !== productId; });
      }
      try { localStorage.setItem('ri-wishlist', JSON.stringify(wishlist)); } catch (e) {}
      setWished(!wished);
    });
  }

  /* ─────────────────────────────────────────────
     6. SIZE CHART MODAL + FOCUS TRAP
  ───────────────────────────────────────────── */
  function initSizeModal() {
    /* Open triggers */
    qsa('[data-modal]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modalId = trigger.dataset.modal;
        var modal   = qs('#' + modalId);
        if (!modal) return;
        modal.setAttribute('aria-hidden', 'false');
        modal._trigger = trigger;
        trapFocus(modal);
        /* Unit toggle init */
        initUnitToggle(modal);
      });
    });

    /* Close: button + backdrop + Escape */
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('ri-size-modal__close') ||
          e.target.classList.contains('ri-size-modal__backdrop')) {
        closeModal(e.target.closest('.ri-size-modal'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = qs('.ri-size-modal[aria-hidden="false"]');
        if (open) closeModal(open);
      }
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    if (modal._trigger) modal._trigger.focus();
  }

  function trapFocus(modal) {
    var panel = qs('.ri-size-modal__panel', modal);
    if (!panel) return;
    var focusable = qsa(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      panel
    ).filter(function (el) { return !el.disabled; });
    if (!focusable.length) return;
    focusable[0].focus();

    panel.addEventListener('keydown', function handler(e) {
      if (e.key !== 'Tab') return;
      if (modal.getAttribute('aria-hidden') === 'true') {
        panel.removeEventListener('keydown', handler);
        return;
      }
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });
  }

  function initUnitToggle(modal) {
    qsa('.ri-unit-btn', modal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('.ri-unit-btn', modal).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var unit = btn.dataset.unit;
        qsa('[data-unit-table]', modal).forEach(function (table) {
          table.hidden = table.dataset.unitTable !== unit;
        });
      });
    });
  }

  /* ─────────────────────────────────────────────
     7. DRAG TO SCROLL (Complete the Look)
     Momentum-based drag scrolling with 60fps updates
  ───────────────────────────────────────────── */
  function initDragToScroll() {
    var scrollContainers = qsa('.ri-related-scroll');
    
    scrollContainers.forEach(function (container) {
      var isDown = false;
      var startX;
      var scrollLeft;
      var velocity = 0;
      var lastX = 0;
      var lastTime = 0;
      var rafId = null;
      var isMomentumScrolling = false;

      // Cancel any ongoing momentum scroll
      function cancelMomentum() {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        isMomentumScrolling = false;
      }

      // Momentum scroll animation
      function momentumScroll() {
        if (Math.abs(velocity) < 0.5) {
          isMomentumScrolling = false;
          return;
        }
        
        container.scrollLeft += velocity;
        velocity *= 0.95; // Friction factor
        
        rafId = requestAnimationFrame(momentumScroll);
      }

      container.addEventListener('mousedown', function (e) {
        cancelMomentum();
        isDown = true;
        container.classList.add('is-dragging');
        startX = e.pageX;
        scrollLeft = container.scrollLeft;
        lastX = e.pageX;
        lastTime = Date.now();
        velocity = 0;
        e.preventDefault();
      });

      container.addEventListener('mouseleave', function () {
        if (isDown) {
          isDown = false;
          container.classList.remove('is-dragging');
          // Start momentum on release
          if (Math.abs(velocity) > 2) {
            isMomentumScrolling = true;
            rafId = requestAnimationFrame(momentumScroll);
          }
        }
      });

      container.addEventListener('mouseup', function () {
        if (isDown) {
          isDown = false;
          container.classList.remove('is-dragging');
          // Start momentum on release
          if (Math.abs(velocity) > 2) {
            isMomentumScrolling = true;
            rafId = requestAnimationFrame(momentumScroll);
          }
        }
      });

      container.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        
        var currentX = e.pageX;
        var currentTime = Date.now();
        var deltaX = currentX - startX;
        
        // Calculate velocity for momentum
        var timeDelta = currentTime - lastTime;
        if (timeDelta > 0) {
          velocity = (currentX - lastX) / timeDelta * 16; // Scale to ~60fps
        }
        
        container.scrollLeft = scrollLeft - deltaX;
        
        lastX = currentX;
        lastTime = currentTime;
      });

      // Prevent default drag behavior on images
      qsa('img', container).forEach(function (img) {
        img.addEventListener('dragstart', function (e) {
          e.preventDefault();
        });
      });

      // Stop momentum if user interacts again
      container.addEventListener('wheel', cancelMomentum);
      container.addEventListener('touchstart', cancelMomentum);
    });
  }


})();
